import type { AppRouteRecordRaw } from '@/router/types'

/**
 * AI智慧收银独立路由组
 * 新窗口打开路径：/canteen/home
 * 指向紫金餐厅收银系统
 *
 * @deprecated 该 /canteen 是紫金餐厅收银（daike-app）的别名入口；
 *             收银统一入口为 daike.ts 的 /cash，后续确认无外部依赖后删除本别名。
 */
const canteenRoutes: AppRouteRecordRaw[] = [
  {
    path: '/canteen',
    component: () => import('@/views/daike-app/layout/index.vue'),
    redirect: '/canteen/home',
    name: 'CanteenRoot',
    meta: { title: 'AI智慧餐厅', hidden: true },
    children: [
      {
        path: 'home',
        component: () => import('@/views/daike-app/home/index.vue'),
        name: 'CanteenHome',
        meta: { title: '系统首页', hidden: true }
      },
      {
        path: 'cashier',
        component: () => import('@/views/daike-app/cashier/index.vue'),
        name: 'CanteenCashier',
        meta: { title: '收银台', hidden: true }
      },
      {
        path: 'setting',
        component: () => import('@/views/daike-app/setting/index.vue'),
        name: 'CanteenSetting',
        meta: { title: '系统设置', hidden: true }
      }
    ]
  }
]

export default canteenRoutes
